"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cartErrorHandler = void 0;
const fluture_1 = require("fluture");
const ts_pattern_1 = require("ts-pattern");
const perimeterX_1 = require("../perimeterX");
const actions_1 = require("./actions");
/**
 * Handles defined error conditions.
 * @package
 */
const cartErrorHandler = (error) => (0, ts_pattern_1.match)(error)
    /** A non perimeterX error means the user does not own the cart, so we create a new cart using the same items */
    .when(e => !(0, perimeterX_1.isPerimeterXError)(e) && e.status === 403, actions_1.resetAndReplicateCart)
    /** If non of the above conditions are met we just reject with the original error and do nothing special */
    .otherwise(() => (0, fluture_1.reject)(error));
exports.cartErrorHandler = cartErrorHandler;
//# sourceMappingURL=errorHandler.js.map